module.exports = __webpack_public_path__ + "static/byron-bc7f8edd73c1e979bac7b6fa429741d3.png";